export const BOOTCAMP_PAGE_POSTHOG_VARIANTS = ['control', 'test'] as const;

/**
 * Candidate follow-up arm. The Clarity Home bootcamp page is reviewable at
 * /courses/ai-trading-bootcamp/clarity-home and is not assigned anywhere yet.
 * Rob loads the PostHog experiment later; nothing here evaluates a flag.
 */
export const BOOTCAMP_CLARITY_HOME_CANDIDATE = {
  name: 'ai_trading_bootcamp_clarity_home_candidate',
  status: 'planned',
  reviewPath: '/courses/ai-trading-bootcamp/clarity-home',
  component: 'CoursePageClarityHome',
  primaryMetric: 'Live Bootcamp checkout conversion',
  secondaryMetrics: ['Live Bootcamp payment conversion', 'Live Bootcamp revenue per exposed user'],
} as const;

export const BOOTCAMP_PAGE_EXPERIMENT = {
  name: 'ai_trading_bootcamp_control_vs_clarity_2026_08_31',
  featureFlag: 'ai-trading-bootcamp-control-vs-clarity-2026-08-31',
  posthogExperimentId: 459167,
  predecessorPosthogExperimentId: 445277,
  status: 'active',
  posthogVariants: BOOTCAMP_PAGE_POSTHOG_VARIANTS,
  variants: {
    control: 'Current bootcamp page',
    test: 'Clarity bootcamp page',
  },
  primaryMetric: 'Live Bootcamp checkout conversion',
  secondaryMetrics: ['Live Bootcamp payment conversion', 'Live Bootcamp revenue per exposed user'],
} as const;
